import styled from 'styled-components'

export const ScrollableContent = styled.div`
  overflow-y: auto;
  flex: 1;
`

export const FormContainer = styled.form`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`

export const SuccessContainer = styled.div`
  padding: 20px;
`

export const SuccessTitle = styled.h3`
  margin-top: 0;
`

export const ButtonGroup = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
`
